import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { useDocumentTitle } from '../../common/hooks/useDocumentTitle';
import { useRole } from '../../common/hooks/useRole';
import { Page } from '../../common/Page/Page';
import { PageGrid } from '../../common/PageGrid';
import { Box } from '../../common/ui/Box';
import { CreateVesselButton } from '../CreateVessel/CreateVesselButton';

import { ExportAllVesselsButton } from './components/ExportAllVesselsButton';
import { VesselDataMigrationButton } from './components/VesselDataMigration/VesselDataMigrationButton';
import { VesselFilterPills } from './components/VesselFilterPills';
import { VesselStatusTabs } from './components/VesselStatusTabs';
import { VesselOverviewTable } from './VesselOverviewTable';

export const VesselOverviewPage = () => {
    useDocumentTitle(translate('vessel.overviewpagetitle'));
    const role = useRole();

    return (
        <Page>
            <PageGrid>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Text variant="headline" as="h1">
                        {translate('vessel.overviewpagetitle')}
                    </Text>

                    {role.hasAnyAdminRights() ? (
                        <Box display="flex" gap={8}>
                            {role.isSuperAdmin() ? <VesselDataMigrationButton /> : null}
                            {role.isSuperAdmin() ? <ExportAllVesselsButton /> : null}
                            <CreateVesselButton />
                        </Box>
                    ) : null}
                </Box>

                <Box display="flex" flexDirection="column" gap={8}>
                    <VesselStatusTabs />
                    <VesselFilterPills />
                    <VesselOverviewTable />
                </Box>
            </PageGrid>
        </Page>
    );
};
